import { useMutation, useQueryClient } from '@tanstack/react-query';

import { endpoints } from 'global/endpoints';
import http from 'utils/http';

export interface ISaveReportSettings {
  show_timesheet_notes: boolean;
  show_employee_id: boolean;
  show_job_code: boolean;
  show_mileage: boolean;
  time_in_decimal: boolean;
  show_approved_times: boolean;
  include_inactive: boolean;
  include_premium_pay: boolean;
  show_custom_fields?: boolean;
}

const saveReportSettings = (postData: ISaveReportSettings) => {
  return http().post(endpoints.companySettings.reportSettings, postData);
};

export function useSaveReportSettings() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: saveReportSettings,
    onSettled: (data: any) => {
      if (data) {
        queryClient.invalidateQueries({ queryKey: ['fetchUserDetails'] });
      }
    },
  });
}
